import React from 'react';
import { Input } from 'antd';
import { t } from '../../../i18n';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../utils/languageUtils';

const { TextArea } = Input;

interface BatchInputFilterItemProps {
    label: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    placeholder?: string;
    rows?: number;
}

const BatchInputFilterItem: React.FC<BatchInputFilterItemProps> = ({ 
    label, 
    value, 
    onChange, 
    onBlur,
    className,
    spanClassName,
    disabled,
    placeholder,
    rows = 3
}) => {
    // 使用统一的样式 Hook，根据语言自动返回合适的样式类名
    const containerClassName = useFilterContainerClassName(className);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();
    const MAX_VISIBLE_ROWS = 6;
    const lineCount = React.useMemo(() => {
        if (!value) return 0;
        return value.split(/\r?\n/).length;
    }, [value]);
    const visibleRows = rows > 1 ? Math.min(Math.max(rows, lineCount), MAX_VISIBLE_ROWS) : 1;
    const visibleHeightPx = visibleRows * 32;

    const textAreaPlaceholder = placeholder === undefined ? t('components.input.typeIn') : placeholder;
    return (
        <div className={containerClassName}>
            <span className={labelClassName}>{label}</span>
            <div className={`${inputContainerClassName} ${rows === 1 ? 'flex items-center' : ''}`}>
                <TextArea
                    placeholder={textAreaPlaceholder}
                    value={value}
                    allowClear
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    rows={rows}
                    // 统一使用受控高度：基于内容行数撑高（最多 6 行），超过后在框内滚动
                    autoSize={false}
                    className={rows === 1 ? "h-8 [&_.ant-input]:h-8 [&_.ant-input]:leading-8 [&_.ant-input]:py-0" : ""}
                    style={{
                        width: '100%',
                        resize: 'none',
                        ...(rows > 1 ? {
                            height: `${visibleHeightPx}px`,
                            minHeight: `${rows * 32}px`,
                            maxHeight: `${MAX_VISIBLE_ROWS * 32}px`,
                            overflowY: lineCount > MAX_VISIBLE_ROWS ? 'auto' as const : 'hidden' as const,
                        } : {}),
                        ...(rows === 1 ? { 
                            height: '32px', 
                            minHeight: '32px', 
                            maxHeight: '32px',
                            paddingTop: '0px',
                            paddingBottom: '0px',
                            lineHeight: '32px'
                        } : {})
                    }}
                />
            </div>
        </div>
    );
};

export default BatchInputFilterItem;
